import ComponentHelper from '../../../supers/ComponentHelper';
import Modal from 'react-modal';
import React from 'react';
import './create-tenant-modal.css';
import InputField from '../../../components/input-field/InputField';
import ValidationService from '../../../services/ValidationService';
const VS = new ValidationService();

class CreateTenantModal extends ComponentHelper {
	constructor(props) {
		super(props);
		this.setInitialData(props);
	}

	setInitialData = props => {
		this.data = {
			title: 'New Tenant',
			tenantName: '',
			logPersonalIdentifyingInfo: true,
			activeTab: 0
		};
	};

	// Clear component state when modal is re-open
	componentWillReceiveProps(nextProps) {
		if (!this.props.isOpen && nextProps.isOpen) {
			this.observe(() => {
				this.setInitialData(nextProps);
			});
		}
	}

	isValidInput() {
		let name = this.data.tenantName;
		return name.length > 0 && name.length <= 15;
	}

	onNameChange = evt => {
		this.observe(() => {
			if (VS.validateName(evt.target.value)) {
				this.data[evt.target.name] = evt.target.value;
			}
		});
	};

	onCreate = () => {
		this.props.onConfirm(this.data);
	};

	toggleInfoLog = () => {
		this.setData('logPersonalIdentifyingInfo', !this.data.logPersonalIdentifyingInfo);
	};

	render() {
		let { isOpen } = this.props;
		let { title, tenantName } = this.data;
		return (
			<Modal
				contentLabel="Modal"
				ariaHideApp={false}
				isOpen={isOpen}
				className="create-tenant-modal animated zoomIn"
				overlayClassName="dialog-modal-overlay vbox hcenter vcenter"
			>
				<div className="modal-header">{title}</div>
				<div className="modal-body">
					<InputField
						label="Tenant Name"
						name="tenantName"
						type="text"
						value={tenantName}
						handleChange={this.onNameChange}
						placeholder="Enter a unique name"
						required
						autoFocus
					/>
					<div className="hbox vcenter">
						<input type="checkbox" checked={this.data.logPersonalIdentifyingInfo} onClick={this.toggleInfoLog} />
						<div className="label">Track Personally Identifiable Information (PII)</div>
					</div>
					<div className="disclaimer">Uncheck to disable Personally Identifiable Information from being tracked and stored.</div>
				</div>
				<div className="btn-ctn">
					<button className="btn cancel-btn" onClick={this.props.onCancel}>
						Cancel
					</button>
					<button className="btn primary" onClick={this.onCreate} disabled={!this.isValidInput()}>
						Create
					</button>
				</div>
			</Modal>
		);
	}
}
export default CreateTenantModal;



// WEBPACK FOOTER //
// ./src/views/tenant-list/create-tenant-modal/CreateTenantModal.js